import React from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Maintenance from './pages/Maintenance';
import routes from './routes';
import { MAINTENANCE_FULL } from './constants';
import './styles/main.scss';

const App = () => (
    <Switch>
        {MAINTENANCE_FULL && <Route path="*" component={Maintenance} />}
        {routes.map(route => {
            let k = route.path;
            if (Array.isArray(route.path)) {
                k = route.path[0];
            }
            k = k.replace(/[^A-Z0-9]/ig, "");
            return (
                <Route key={k} exact {...route} />
            );
        })}
        {process.env.RAZZLE_APP_ENV !== 'production' && <Redirect exact from="/" to="/forms" />}
        <Route exact path="/forms" component={Home} />
        <Route path="*" render={({ staticContext }) => {
          if (staticContext) { staticContext.status = 404; }
          return <NotFound />
        }} />
    </Switch>
);

export default App;
